var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cc-button",on:{"click":_vm.onClick}},[(_vm.largerStyle)?_c('div',{staticClass:"cc-button-click-larger",style:(_vm.largerStyle)}):_vm._e(),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.reservationText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }